// @flow
import { v4 as uuid } from 'uuid';
import values from 'ramda/es/values';

import { type OrderType } from './OrderData';


type OrderFromApiType = {
  ...$Exact<OrderType>,
  [string]: mixed,
}

const convertOrderToPost = (orderFromApi: OrderFromApiType, personId: number, date?: string): OrderType => {
  const {
    customer_id: apiCustomerId,
    guid,
    items,
    datetime,
    sale_point_id: sellPointId,
    building_id: buildingId,
  } = orderFromApi;

  return {
    customer_id: apiCustomerId || personId,
    sale_point_id: sellPointId,
    building_id: buildingId,
    guid: guid || uuid(),
    items: items ? values(items) : [],
    // $FlowFixMe
    ...(datetime ? { time: datetime } : {}),
    status: 0,
    ...(date ? { time: date } : {}),
  };
};

export default convertOrderToPost;
